import { getMealPlanMerchandisingRegionId } from 'common/meal-plan/MerchandisingRegion';
import React from 'react';
import belkisGate from 'src/assets/img/login-modal/belkis-gate.jpg';
import belkis from 'src/assets/img/login-modal/belkis.jpg';
import drew from 'src/assets/img/login-modal/drew.jpg';
import kimberly from 'src/assets/img/login-modal/kimberly.jpg';
import leanne from 'src/assets/img/login-modal/leanne.jpg';
import leon from 'src/assets/img/login-modal/leon.jpg';
import maen from 'src/assets/img/login-modal/maen.jpg';
import shaelin from 'src/assets/img/login-modal/shaelin.jpg';
import tajah from 'src/assets/img/login-modal/tajah.jpg';

export interface FeaturedShef {
  name: string;
  image: string;
}

const EAST_COAST_SHEFS: FeaturedShef[] = [
  { name: 'Leanne', image: leanne },
  { name: 'Leon', image: leon },
  { name: 'Maen', image: maen },
];

const WEST_COAST_SHEFS: FeaturedShef[] = [
  { name: 'Kimberly', image: kimberly },
  { name: 'Tajah', image: tajah },
  { name: 'Belkis', image: belkis },
];

const SHEFS_BY_REGION: Record<number, FeaturedShef[]> = {
  1: EAST_COAST_SHEFS,
  2: WEST_COAST_SHEFS,
  5: WEST_COAST_SHEFS,
  6: WEST_COAST_SHEFS,
  7: EAST_COAST_SHEFS,
  8: WEST_COAST_SHEFS,
  9: EAST_COAST_SHEFS,
  10: EAST_COAST_SHEFS,
};

/**
 * Belkis is `belkisGate` here, a newer photo than the `belkis` the region sets use. Pointing both at
 * one file would change what control renders.
 */
export const DEFAULT_FEATURED_SHEFS: FeaturedShef[] = [
  { name: 'Shaelin', image: shaelin },
  { name: 'Belkis', image: belkisGate },
  { name: 'Drew', image: drew },
];

/** Undefined for an unmapped region, which control renders as no trio at all. */
export const getFeaturedShefs = (regionId: number | undefined): FeaturedShef[] | undefined =>
  regionId === undefined ? undefined : SHEFS_BY_REGION[getMealPlanMerchandisingRegionId(regionId)];

export const ShefTrio: React.FC<{ shefs: FeaturedShef[]; className?: string }> = ({ shefs, className }) => (
  <div className={className}>
    {shefs.map((shef) => (
      <div className='flex flex-col items-center gap-1' key={shef.name}>
        <img className='size-20 max-w-none rounded-full object-cover' src={shef.image} alt={shef.name} />
        <span className='whitespace-nowrap text-caption-700 text-eggplant'>
          Shef <span className='font-quick-writers text-h6 text-raspberry'>{shef.name}</span>
        </span>
      </div>
    ))}
  </div>
);
